import i18n from "../../../../locales";
import { SagaIterator } from "redux-saga";
import { requester } from "../../../../libs/requester";
import { put, call, takeLatest } from "redux-saga/effects";
import { saveCatalog } from "../../repository/actions";
import { links } from "../../../../utils/links";
import { createNotification } from "../../../../utils/createNotification";
import { setAppLoading } from "../../../app/repository/actions";

function* getCatalogWorker(): SagaIterator {
  try {
    yield put(setAppLoading(true));
    const { data, isError, message } = yield call(
      requester.get,
      links.category
    );
    if (isError) {
      createNotification({
        title: i18n.t("error"),
        message,
        type: "danger",
      });
    } else {
      yield put(saveCatalog(data));
    }
  } catch (error) {
    console.error("getCatalogWorker: ", error);
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* getCatalogWatcher() {
  yield takeLatest("@saga/GET_CATALOG", getCatalogWorker);
}
